import { staticImagePath, Text } from '@lune-fe/lune-ui-lib'
import { Box } from '@mui/material'
import { FC } from 'react'

import image2 from '../../images/pdf-footer-img-2.png'
import image3 from '../../images/pdf-footer-img-3.png'

export const PdfFooter: FC = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 9,
                mt: 9,
            }}
        >
            <Box>
                <Text variant={'body3'}>
                    {`Lune's methodology is based on the GLEC Framework and has been certified by the `}
                    <a
                        href={`https://smart-freight-centre-media.s3.amazonaws.com/documents/2023_SFC_Accreditation_Statement_Lune.pdf`}
                    >
                        Smart Freight Centre
                    </a>{' '}
                    to be ISO 14083 compliant. These calculation results have been established in
                    accordance with ISO 14083:2023.
                    <br />
                    <br />
                    Read more about our methodology{' '}
                    <a href={'https://docs.lune.co/general-concepts/logistics-methodology'}>here</a>
                    .
                </Text>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                <img
                    width={114}
                    height={64.07}
                    src={staticImagePath(image3)}
                    alt={'pdf-footer-image-3'}
                />
                <img
                    width={79}
                    height={64.25}
                    src={staticImagePath(image2)}
                    alt={'pdf-footer-image-2'}
                />
            </Box>
        </Box>
    )
}

export default PdfFooter
